import type { Meta, StoryFn } from '@storybook/react';
import type { AppStatusBarProps } from './AppStatusBar';

import { AppStatusBar } from './AppStatusBar';

const codeString = '<AppStatusBar severity={severity} message={message} key={key} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/AppStatusBar',
  component: AppStatusBar,
  argTypes: {
    severity: {
      options: ['info', 'warning', 'error'],
      control: { type: 'radio' },
    },
  },
  parameters: {
    inspectComponent: AppStatusBar,
    codeString: codeString,
  },
} as Meta<AppStatusBarProps>;

const Template: StoryFn<AppStatusBarProps> = (args) => <AppStatusBar {...args} />;

const defaultArgs: Partial<AppStatusBarProps> = {
  message: 'Dit is de ontwikkelomgeving van Storybook. Hier kun je componenten bekijken en testen!.',
  severity: 'warning',
};

export const AppStatusBarExample = Template.bind({});
AppStatusBarExample.args = {
  ...defaultArgs,
};
